<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">List group</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/components/list-group/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- List: Basic  -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic example</h5>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item">Cras justo odio</li>
                    <li class="list-group-item">Dapibus ac facilisis in</li>
                    <li class="list-group-item">Morbi leo risus</li>
                    <li class="list-group-item">Porta ac consectetur ac</li>
                    <li class="list-group-item">Vestibulum at eros</li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group&quot;&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Cras justo odio&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Morbi leo risus&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Porta ac consectetur ac&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Vestibulum at eros&lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: Active and Disabled  -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Active items</h5>
              <p>Add <code class="text-danger">.active</code> to a <code class="text-danger">.list-group-item</code> to
                indicate the current active selection.</p>
              <p>Add <code class="text-danger">.disabled</code> to a <code class="text-danger">.list-group-item</code>
                to
                make it <em>appear</em> disabled. Note that some elements with <code
                  class="text-danger">.disabled</code>
                will also require custom JavaScript to fully disable their click events (e.g., links).</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item active">Cras justo odio</li>
                    <li class="list-group-item">Dapibus ac facilisis in</li>
                    <li class="list-group-item disabled">Morbi leo risus</li>
                    <li class="list-group-item">Porta ac consectetur ac</li>
                    <li class="list-group-item">Vestibulum at eros</li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group&quot;&gt;
        &lt;li class=&quot;list-group-item active&quot;&gt;Cras justo odio&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;
        &lt;li class=&quot;list-group-item disabled&quot;&gt;Morbi leo risus&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Porta ac consectetur ac&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Vestibulum at eros&lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: Links and buttons -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Links and buttons</h5>
              <p>Use <code class="text-danger">&lt;a&gt;</code>s or <code class="text-danger">&lt;button&gt;</code>s to
                create <em>actionable</em> list group items with hover, disabled, and active states by adding <code
                  class="text-danger">.list-group-item-action</code>. We separate these pseudo-classes to ensure list
                groups made of non-interactive elements (like <code class="text-danger">&lt;li&gt;</code>s or <code
                  class="text-danger">&lt;div&gt;</code>s) don’t provide a click or tap affordance.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="list-group">
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action active">Cras justo
                      odio</a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action">Dapibus ac facilisis
                      in</a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action">Morbi leo risus</a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action">Porta ac consectetur
                      ac</a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action disabled" tabindex="-1"
                      aria-disabled="true">Vestibulum at eros</a>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;list-group&quot;&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action active&quot;&gt;Cras justo odio&lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action&quot;&gt;Dapibus ac facilisis in&lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action&quot;&gt;Morbi leo risus&lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action&quot;&gt;Porta ac consectetur ac&lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action disabled&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Vestibulum at eros&lt;/a&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: Flush -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Flush</h5>
              <p>Add <code class="text-danger">.list-group-flush</code> to remove some borders and rounded corners to
                render list group items edge-to-edge in a parent container (e.g., cards).</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">Cras justo odio</li>
                    <li class="list-group-item">Dapibus ac facilisis in</li>
                    <li class="list-group-item">Morbi leo risus</li>
                    <li class="list-group-item">Porta ac consectetur ac</li>
                    <li class="list-group-item">Vestibulum at eros</li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group list-group-flush&quot;&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Cras justo odio&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Morbi leo risus&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Porta ac consectetur ac&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Vestibulum at eros&lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: Horizontal -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Horizontal</h5>
              <p>Add <code class="text-danger">.list-group-horizontal</code> to change the layout of list group items
                from
                vertical to horizontal across all breakpoints. Alternatively, choose a responsive variant <code
                  class="text-danger">.list-group-horizontal</code> to make a list group horizontal
                starting
                at that breakpoint’s <code class="text-danger">min-width</code>. Currently <strong>horizontal list
                  groups
                  cannot be combined with flush list groups.</strong></p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group list-group-horizontal">
                    <li class="list-group-item">Cras justo odio</li>
                    <li class="list-group-item">Dapibus ac facilisis in</li>
                    <li class="list-group-item">Morbi leo risus</li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group list-group-horizontal&quot;&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Cras justo odio&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Morbi leo risus&lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: Contextual classes -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Contextual classes</h5>
              <p>Use contextual classes to style list items with a stateful background and color.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item">Dapibus ac facilisis in</li>

                    <li class="list-group-item list-group-item-primary">A simple primary list group item</li>
                    <li class="list-group-item list-group-item-secondary">A simple secondary list group item</li>
                    <li class="list-group-item list-group-item-success">A simple success list group item</li>
                    <li class="list-group-item list-group-item-danger">A simple danger list group item</li>
                    <li class="list-group-item list-group-item-warning">A simple warning list group item</li>
                    <li class="list-group-item list-group-item-info">A simple info list group item</li>
                    <li class="list-group-item list-group-item-light">A simple light list group item</li>
                    <li class="list-group-item list-group-item-dark">A simple dark list group item</li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group&quot;&gt;
        &lt;li class=&quot;list-group-item&quot;&gt;Dapibus ac facilisis in&lt;/li&gt;

        &lt;li class=&quot;list-group-item list-group-item-primary&quot;&gt;A simple primary list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-secondary&quot;&gt;A simple secondary list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-success&quot;&gt;A simple success list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-danger&quot;&gt;A simple danger list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-warning&quot;&gt;A simple warning list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-info&quot;&gt;A simple info list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-light&quot;&gt;A simple light list group item&lt;/li&gt;
        &lt;li class=&quot;list-group-item list-group-item-dark&quot;&gt;A simple dark list group item&lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: With badges -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">With badges</h5>
              <p>Add badges to any list group item to show unread counts, activity, and more with the help of some</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      Cras justo odio
                      <span class="badge bg-primary bg-pill">14</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      Dapibus ac facilisis in
                      <span class="badge bg-primary bg-pill">2</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      Morbi leo risus
                      <span class="badge bg-primary bg-pill">1</span>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;list-group&quot;&gt;
        &lt;li class=&quot;list-group-item d-flex justify-content-between align-items-center&quot;&gt;
          Cras justo odio
          &lt;span class=&quot;badge bg-primary bg-pill&quot;&gt;14&lt;/span&gt;
        &lt;/li&gt;
        &lt;li class=&quot;list-group-item d-flex justify-content-between align-items-center&quot;&gt;
          Dapibus ac facilisis in
          &lt;span class=&quot;badge bg-primary bg-pill&quot;&gt;2&lt;/span&gt;
        &lt;/li&gt;
        &lt;li class=&quot;list-group-item d-flex justify-content-between align-items-center&quot;&gt;
          Morbi leo risus
          &lt;span class=&quot;badge bg-primary bg-pill&quot;&gt;1&lt;/span&gt;
        &lt;/li&gt;
    &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>


            <!-- List: Custom content -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Custom content</h5>
              <p>Add nearly any HTML within, even for linked list groups like the one below, with the help of <a
                  href="https://getbootstrap.com/docs/4.5/utilities/flex/">flexbox utilities</a>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="list-group">
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action active">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">List group item heading</h5>
                        <small>3 days ago</small>
                      </div>
                      <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus
                        varius blandit.</p>
                      <small>Donec id elit non mi porta.</small>
                    </a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">List group item heading</h5>
                        <small class="text-muted">3 days ago</small>
                      </div>
                      <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus
                        varius blandit.</p>
                      <small class="text-muted">Donec id elit non mi porta.</small>
                    </a>
                    <a href="javascript:void(0);" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">List group item heading</h5>
                        <small class="text-muted">3 days ago</small>
                      </div>
                      <p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus
                        varius blandit.</p>
                      <small class="text-muted">Donec id elit non mi porta.</small>
                    </a>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;list-group&quot;&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action active&quot;&gt;
            &lt;div class=&quot;d-flex w-100 justify-content-between&quot;&gt;
                &lt;h5 class=&quot;mb-1&quot;&gt;List group item heading&lt;/h5&gt;
                &lt;small&gt;3 days ago&lt;/small&gt;
            &lt;/div&gt;
            &lt;p class=&quot;mb-1&quot;&gt;Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.&lt;/p&gt;
            &lt;small&gt;Donec id elit non mi porta.&lt;/small&gt;
        &lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action&quot;&gt;
            &lt;div class=&quot;d-flex w-100 justify-content-between&quot;&gt;
                &lt;h5 class=&quot;mb-1&quot;&gt;List group item heading&lt;/h5&gt;
                &lt;small class=&quot;text-muted&quot;&gt;3 days ago&lt;/small&gt;
            &lt;/div&gt;
            &lt;p class=&quot;mb-1&quot;&gt;Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.&lt;/p&gt;
            &lt;small class=&quot;text-muted&quot;&gt;Donec id elit non mi porta.&lt;/small&gt;
        &lt;/a&gt;
        &lt;a href=&quot;javascript:void(0);&quot; class=&quot;list-group-item list-group-item-action&quot;&gt;
            &lt;div class=&quot;d-flex w-100 justify-content-between&quot;&gt;
                &lt;h5 class=&quot;mb-1&quot;&gt;List group item heading&lt;/h5&gt;
                &lt;small class=&quot;text-muted&quot;&gt;3 days ago&lt;/small&gt;
            &lt;/div&gt;
            &lt;p class=&quot;mb-1&quot;&gt;Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.&lt;/p&gt;
            &lt;small class=&quot;text-muted&quot;&gt;Donec id elit non mi porta.&lt;/small&gt;
        &lt;/a&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- List: JavaScript behavior -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">JavaScript behavior</h5>
              <p>Use the tab JavaScript plugin—include it individually or through the compiled <code
                  class="text-danger">bootstrap.js</code> file—to extend our list group to create tabbable panes of
                local
                content.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <div class="row">
                    <div class="col-4">
                      <div class="list-group" id="list-tab" role="tablist">
                        <a class="list-group-item list-group-item-action active" id="list-home-list"
                          href="javascript:void(0)" (click)="onMenuTab('1')" [ngClass]="{'active': homeTab}">Home</a>
                        <a class="list-group-item list-group-item-action" id="list-profile-list"
                          href="javascript:void(0)" (click)="onMenuTab('2')"
                          [ngClass]="{'active': profileTab}">Profile</a>
                        <a class="list-group-item list-group-item-action" id="list-messages-list"
                          href="javascript:void(0)" (click)="onMenuTab('3')"
                          [ngClass]="{'active': messagesTab}">Messages</a>
                        <a class="list-group-item list-group-item-action" id="list-settings-list"
                          href="javascript:void(0)" (click)="onMenuTab('4')"
                          [ngClass]="{'active': settingTab}">Settings</a>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade active show" id="list-home" [ngClass]="{'show active': homeTab}">
                          <p>Velit aute mollit ipsum ad dolor consectetur nulla officia culpa adipisicing exercitation
                            fugiat tempor. Voluptate deserunt sit sunt nisi aliqua fugiat proident ea ut. Mollit
                            voluptate
                            reprehenderit occaecat nisi ad non minim tempor sunt voluptate consectetur exercitation id
                            ut
                            nulla. Ea et fugiat aliquip nostrud sunt incididunt consectetur culpa aliquip eiusmod dolor.
                            Anim ad Lorem aliqua in cupidatat nisi enim eu nostrud do aliquip veniam minim.</p>
                        </div>
                        <div class="tab-pane fade" id="list-profile" [ngClass]="{'show active': profileTab}">
                          <p>Cupidatat quis ad sint excepteur laborum in esse qui. Et excepteur consectetur ex nisi eu
                            do
                            cillum ad laborum. Mollit et eu officia dolore sunt Lorem culpa qui commodo velit ex amet id
                            ex. Officia anim incididunt laboris deserunt anim aute dolor incididunt veniam aute dolore
                            do
                            exercitation. Dolor nisi culpa ex ad irure in elit eu dolore. Ad laboris ipsum reprehenderit
                            irure non commodo enim culpa commodo veniam incididunt veniam ad.</p>
                        </div>
                        <div class="tab-pane fade" id="list-messages" [ngClass]="{'show active': messagesTab}">
                          <p>Ut ut do pariatur aliquip aliqua aliquip exercitation do nostrud commodo reprehenderit aute
                            ipsum voluptate. Irure Lorem et laboris nostrud amet cupidatat cupidatat anim do ut velit
                            mollit consequat enim tempor. Consectetur est minim nostrud nostrud consectetur irure labore
                            voluptate irure. Ipsum id Lorem sit sint voluptate est pariatur eu ad cupidatat et deserunt
                            culpa sit eiusmod deserunt. Consectetur et fugiat anim do eiusmod aliquip nulla laborum elit
                            adipisicing pariatur cillum.</p>
                        </div>
                        <div class="tab-pane fade" id="list-settings" [ngClass]="{'show active': settingTab}">
                          <p>Irure enim occaecat labore sit qui aliquip reprehenderit amet velit. Deserunt ullamco ex
                            elit
                            nostrud ut dolore nisi officia magna sit occaecat laboris sunt dolor. Nisi eu minim cillum
                            occaecat aute est cupidatat aliqua labore aute occaecat ea aliquip sunt amet. Aute mollit
                            dolor ut exercitation irure commodo non amet consectetur quis amet culpa. Quis ullamco nisi
                            amet qui aute irure eu. Magna labore dolor quis ex labore id nostrud deserunt dolor eiusmod
                            eu
                            pariatur culpa mollit in irure.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;row&quot;&gt;
        &lt;div class=&quot;col-4&quot;&gt;
          &lt;div class=&quot;list-group&quot; id=&quot;list-tab&quot; role=&quot;tablist&quot;&gt;
            &lt;a class=&quot;list-group-item list-group-item-action active&quot; id=&quot;list-home-list&quot; data-toggle=&quot;list&quot; href=&quot;javascript:void(0);list-home&quot; role=&quot;tab&quot; aria-controls=&quot;home&quot;&gt;Home&lt;/a&gt;
            &lt;a class=&quot;list-group-item list-group-item-action&quot; id=&quot;list-profile-list&quot; data-toggle=&quot;list&quot; href=&quot;javascript:void(0);list-profile&quot; role=&quot;tab&quot; aria-controls=&quot;profile&quot;&gt;Profile&lt;/a&gt;
            &lt;a class=&quot;list-group-item list-group-item-action&quot; id=&quot;list-messages-list&quot; data-toggle=&quot;list&quot; href=&quot;javascript:void(0);list-messages&quot; role=&quot;tab&quot; aria-controls=&quot;messages&quot;&gt;Messages&lt;/a&gt;
            &lt;a class=&quot;list-group-item list-group-item-action&quot; id=&quot;list-settings-list&quot; data-toggle=&quot;list&quot; href=&quot;javascript:void(0);list-settings&quot; role=&quot;tab&quot; aria-controls=&quot;settings&quot;&gt;Settings&lt;/a&gt;
          &lt;/div&gt;
        &lt;/div&gt;
        &lt;div class=&quot;col-8&quot;&gt;
          &lt;div class=&quot;tab-content&quot; id=&quot;nav-tabContent&quot;&gt;
            &lt;div class=&quot;tab-pane fade show active&quot; id=&quot;list-home&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;list-home-list&quot;&gt;...&lt;/div&gt;
            &lt;div class=&quot;tab-pane fade&quot; id=&quot;list-profile&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;list-profile-list&quot;&gt;...&lt;/div&gt;
            &lt;div class=&quot;tab-pane fade&quot; id=&quot;list-messages&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;list-messages-list&quot;&gt;...&lt;/div&gt;
            &lt;div class=&quot;tab-pane fade&quot; id=&quot;list-settings&quot; role=&quot;tabpanel&quot; aria-labelledby=&quot;list-settings-list&quot;&gt;...&lt;/div&gt;
          &lt;/div&gt;
        &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
